/**
 * exatrek REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: v3
 * Contact: dev@exatrek.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { LocationDataV2Dto } from './locationDataV2Dto';

export interface LocationDatasetV2Dto {
  jobTimeId?: number;
  locations?: Array<LocationDataV2Dto>;
  workstate?: string;
}
